import { useState, useRef, useEffect } from "react";
import { useLang } from "@/context/LangContext";
import { Check, ChevronDown, Coins } from "lucide-react";

export default function CurrencySwitcher({ dark = false }) {
  const { currency, setCurrency, currencyMeta } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="currency-switcher-toggle"
        className={`flex items-center gap-1 px-2 py-1 rounded text-xs font-bold uppercase tracking-widest hover:text-[var(--accent)] transition-colors ${dark ? "text-white/80" : "text-[var(--ink)]"}`}
        aria-label="Change currency"
      >
        <Coins size={14} />
        <span>{currency}</span>
        <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-52 bg-white border border-black/10 rounded shadow-lg overflow-hidden z-50" data-testid="currency-switcher-menu">
          {Object.entries(currencyMeta).map(([k, m]) => (
            <button
              key={k}
              onClick={() => { setCurrency(k); setOpen(false); }}
              data-testid={`currency-option-${k}`}
              className={`w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-[var(--bg-soft)] ${currency === k ? "text-[var(--accent)] font-bold" : "text-[var(--ink)]"}`}
            >
              <span className="flex items-center gap-2"><span>{m.flag}</span> {k} · {m.label}</span>
              {currency === k && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
